/** Subscribe to the sync worker's status (docs/09 §9.1, principle 3). */

import { useEffect, useState } from "react";
import { syncWorker, type SyncStatus } from "@/lib/sync";

export function useSync(): SyncStatus & {
  sync: () => Promise<void>;
  retry: (clientUuid: string) => Promise<void>;
  discard: (clientUuid: string) => Promise<void>;
} {
  const [status, setStatus] = useState<SyncStatus>(syncWorker.getStatus());

  useEffect(() => syncWorker.subscribe(setStatus), []);

  return {
    ...status,
    sync: () => syncWorker.sync(),
    retry: (clientUuid) => syncWorker.retry(clientUuid),
    discard: (clientUuid) => syncWorker.discard(clientUuid),
  };
}
